import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import About from '@/views/about'
import NewsCenter from '@/views/newsCenter'
import Solution from '@/views/solution'
import NewsList from '@/views/newsList'
import NewsDetail from '@/views/newsDetail'
import IntroIhec from '@/views/introduceIhec'
import ProProducts from '@/views/proProducts'
import CompanyPro from '@/views/companyPro'
import Course from '@/views/course'
import IndustrySolution from '@/views/industrySolution'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/newscenter',
    name: 'NewsCenter',
    component: NewsCenter
  }, {
    path: '/about',
    name: 'About',
    component: About
  }, {
    path: '/solution',
    name: 'Solution',
    component: Solution
  }, {
    path: '/newslist',
    name: 'NewsList',
    component: NewsList
  }, {
    path: '/newsdetail',
    name: 'NewsDetail',
    component: NewsDetail
  }, {
    path: '/introduceihec',
    name: 'IntroIhec',
    component: IntroIhec
  }, {
    path: '/proproducts',
    name: 'ProProducts',
    component: ProProducts
  }, {
    path: '/companypro',
    name: 'CompanyPro',
    component: CompanyPro
  }, {
    path: '/course',
    name: 'Course',
    component: Course
  }, {
    path: '/insdustrysolution',
    name: 'IndustrySolution',
    component: IndustrySolution
  }, {
    path: '*',
    redirect: '/'
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js